import { navSections, categories } from "@/mocks/chigua";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="container-page grid grid-cols-1 gap-8 py-12 md:grid-cols-12 md:py-14">
        {/* brand */}
        <div className="md:col-span-5">
          <a href="#top" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-quill-pen-fill text-xl"></i>
            </span>
            <span className="font-display text-lg font-black tracking-tight text-background-50">
              吃瓜<span className="text-primary-300">日报</span>
            </span>
          </a>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
            一档专注娱乐与社会热议话题的每日盘点栏目。热榜排行、爆款精选、专题盘点，帮你把全网最火的瓜吃得明明白白。
          </p>
          <div className="mt-5 flex items-center gap-2">
            {["ri-wechat-2-line", "ri-weibo-line", "ri-bilibili-line", "ri-douban-line"].map((ic) => (
              <a
                key={ic}
                href="#top"
                aria-label="社交媒体"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-700 text-background-300 transition hover:border-accent-400 hover:text-accent-300"
              >
                <i className={ic}></i>
              </a>
            ))}
          </div>
        </div>

        {/* nav */}
        <div className="md:col-span-2">
          <h3 className="text-sm font-bold text-background-50">浏览栏目</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-background-300">
            {navSections.map((n) => (
              <li key={n.id}>
                <a href={`#${n.id}`} className="transition hover:text-accent-300">{n.label}</a>
              </li>
            ))}
          </ul>
        </div>

        {/* categories */}
        <div className="md:col-span-3">
          <h3 className="text-sm font-bold text-background-50">内容品类</h3>
          <ul className="mt-4 grid grid-cols-2 gap-x-2 gap-y-2.5 text-sm text-background-300">
            {categories.map((c) => (
              <li key={c.name}>
                <a href="#featured" className="transition hover:text-accent-300">
                  {c.name}
                  <span className="ml-1 text-xs text-background-500">{c.count}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* contact */}
        <div className="md:col-span-2">
          <h3 className="text-sm font-bold text-background-50">联系我们</h3>
          <ul className="mt-4 space-y-3 text-sm text-background-300">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-accent-300"></i>
              <a href="mailto:hello@chigua-daily.example" className="break-all transition hover:text-accent-300">hello@chigua-daily.example</a>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-accent-300"></i>
              每日 09:00 更新
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-global-line text-accent-300"></i>
              全网免费阅读
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-700/60">
        <div className="container-page flex flex-col items-center justify-between gap-2 py-5 text-xs text-background-400 sm:flex-row">
          <p>© {new Date().getFullYear()} 吃瓜日报 · 理性吃瓜，认真看世界。保留所有权利。</p>
          <p className="flex items-center gap-1.5">
            内容转载需注明来源 · <a href="#top" className="transition hover:text-accent-300">回到顶部 <i className="ri-arrow-up-line"></i></a>
          </p>
        </div>
      </div>
    </footer>
  );
}